export const KPI_TARGET_CPA_CHECK_TTL_MS = 30 * 60 * 1000;

const ISO_CURRENCY_CODE_PATTERN = /^[A-Z]{3}$/;

const normalizePlatform = (value) => {
  if (typeof value !== "string") return "";
  return value.trim().toLowerCase();
};

const normalizeCurrency = (value) => {
  if (typeof value !== "string") return "";
  const currency = value.trim().toUpperCase();
  return ISO_CURRENCY_CODE_PATTERN.test(currency) ? currency : "";
};

/**
 * Fingerprint shared with functions/src/utils/kpiTargetCpaCheck.js.
 * Key order and normalization must stay identical so the client cache matches.
 */
export const getConfiguredKpiTargetCpaParts = (kpiSummary) => {
  const parts = Array.isArray(kpiSummary?.targetCpaParts)
    ? kpiSummary.targetCpaParts
    : [];

  const configured = [];
  const seenPlatforms = new Set();

  parts.forEach((part) => {
    const platform = normalizePlatform(part?.platform);
    const currency = normalizeCurrency(part?.currency);
    const targetCpa = Number(part?.targetCpa);
    if (
      !platform ||
      !currency ||
      !Number.isFinite(targetCpa) ||
      targetCpa <= 0
    ) {
      return;
    }
    if (seenPlatforms.has(platform)) {
      return;
    }
    seenPlatforms.add(platform);
    configured.push({ platform, currency, targetCpa });
  });

  configured.sort((a, b) => a.platform.localeCompare(b.platform));
  return configured;
};

export const buildKpiTargetCpaFingerprint = (kpiSummary) => {
  const primaryKpi =
    typeof kpiSummary?.primaryKpi === "string"
      ? kpiSummary.primaryKpi.trim()
      : "";
  const targets = getConfiguredKpiTargetCpaParts(kpiSummary);
  if (!primaryKpi || targets.length === 0) {
    return null;
  }
  return JSON.stringify({ primaryKpi, targets });
};

export const isKpiTargetCpaCacheFresh = (
  cache,
  fingerprint,
  now = Date.now()
) => {
  if (!cache || !fingerprint || cache.fingerprint !== fingerprint) {
    return false;
  }
  if (typeof cache.lastCheckedAt !== "number") {
    return false;
  }
  return now - cache.lastCheckedAt < KPI_TARGET_CPA_CHECK_TTL_MS;
};
